/* global TOKEN_TRANSIT_PASS_URL */

import PropTypes from 'prop-types';
import React from 'react';
import BusIcon from '@material-ui/icons/DirectionsBus';
import Link from '@material-ui/core/Link';

import CreditCardIcon from 'common/components/icons/CreditCardIcon';
import Cost from 'common/components/Cost';

const RidePayment = ({active, amount, currencyCode, deeplinkService, method, paid}) => {
  if (amount === 0) {
    // TODO right now we can't differenticate between a waived deeplinked fare
    // and one a user purchased
    if (deeplinkService) {
      if (paid) {
        return <div>PAID</div>;
      } else if (active) {
        return (
          <Link
            href={TOKEN_TRANSIT_PASS_URL}
            target="_blank"
            rel="noopener"
            variant="body2"
          >
            BUY PASS
          </Link>
        );
      }
      return null;
    }
    return <div>FARE WAIVED</div>;
  }

  return (
    <React.Fragment>
      {method === 'stripe'
        ? <CreditCardIcon
          style={{height: 12, width: 16, verticalAlign: 'middle', margin: '0 5px 2px 0'}}
        />
        : <BusIcon
          style={{height: 16, width: 16, verticalAlign: 'middle', margin: '0 5px 2px 0'}}
        />
      }
      <Cost amount={amount} currencyCode={currencyCode} />
    </React.Fragment>
  );
};

RidePayment.propTypes = {
  active: PropTypes.bool,
  amount: PropTypes.number.isRequired,
  currencyCode: PropTypes.oneOf(['USD']).isRequired,
  deeplinkService: PropTypes.bool,
  method: PropTypes.oneOf(['stripe', 'vehicle']).isRequired,
  paid: PropTypes.bool,
};

export default RidePayment;



// WEBPACK FOOTER //
// ./src/common/components/RidePayment.js